// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#agencies-edit-company[data-v-54e229f9]  .custom-control-label{color:#000!important}", ""]);
// Exports
module.exports = exports;
